export const CONVERSATIONS_QUERY_KEY = 'conversations';
export const CONVERSATION_TAGS_QUERY_KEY = 'conversationTags';
export const CONVERSATION_METADATA_QUERY_KEY = 'conversationMetadataSettings';
